export default __webpack_public_path__ + "static/media/hoh.10a4f9f9.png";